import { useState } from "react";
import ChangePasswordModal from "../../components/ChangePasswordModal";
import ChangePinModal from "../../components/ChangePinModal";
import { HashLoader } from "react-spinners";
import CreatePinModal from "../../components/CreatePinModal";
import SetSecurityQuestionModal from "../../components/SetSecurityQuestionModal";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AuthenticatorSettings from "../../components/AuthenticatorSettings";

const Security = () => {
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const { user } = useAuth();
  const [showPinModal, setShowPinModal] = useState(false);
  const [showCreatePinModal, setShowCreatePinModal] = useState(false);
  const [showSecurityQuestionModal, setShowSecurityQuestionModal] =
    useState(false);
  const [isLoading] = useState(false);

  return (
    <>
      {isLoading && (
        <div className="fixed top-0 left-0 h-screen w-screen flex items-center justify-center bg-black/20 backdrop-blur-sm z-50">
          <HashLoader />
        </div>
      )}
      {showPasswordModal && (
        <ChangePasswordModal setShowPasswordModal={setShowPasswordModal} />
      )}
      {showPinModal && <ChangePinModal setShowPinModal={setShowPinModal} />}
      {showCreatePinModal && (
        <CreatePinModal setShowPinModal={setShowCreatePinModal} />
      )}
      {showSecurityQuestionModal && (
        <SetSecurityQuestionModal setShowModal={setShowSecurityQuestionModal} />
      )}
      <div className="bg-gray-50 px-5 lg:px-10 py-5 flex items-center justify-center">
        <div className="flex flex-col gap-8 max-w-3xl w-full">
          <div className="flex gap-10 items-center">
            <div>
              <div className="font-medium text-deepBlue text-lg">Security</div>
              <div className="text-gray-700">
                Update your security details here.
              </div>
            </div>
          </div>
          <div className="lg:bg-white lg:shadow lg:rounded-lg w-full flex-col gap-5 flex">
            <div className="lg:p-10 py-5 w-full flex-col gap-10 flex">
              <div className="flex flex-col gap-2 w-full">
                <span className="text-sm font-bold text-gray-700">
                  Password
                </span>
                <button
                  onClick={() => setShowPasswordModal(true)}
                  className="p-4 px-5 border-visaro-gray-300 shadow-sm border rounded-lg font-bold bg-white text-deepBlue text-sm w-fit"
                >
                  Change Password
                </button>
              </div>
              <div className="flex flex-col gap-2 w-full ">
                <span className="text-sm font-bold text-gray-700">
                  Transaction Pin
                </span>
                <div className="flex gap-2 items-center">
                  {!user?.pin_status ? (
                    <Link
                      to="/pin/setup?redirect=/home/settings/security"
                      className="p-4 px-5 border-visaro-gray-300 border shadow-sm rounded-lg font-bold bg-white text-deepBlue text-sm w-fit text-center"
                    >
                      Create Transaction Pin
                    </Link>
                  ) : (
                    <Link
                      to="/pin/change?redirect=/home/settings/security"
                      className="p-4 px-5 border-visaro-gray-300 border shadow-sm rounded-lg font-bold bg-white text-deepBlue text-sm w-fit text-center"
                    >
                      Change Transaction Pin
                    </Link>
                  )}
                </div>
              </div>
              <AuthenticatorSettings />
              <div className="flex flex-col gap-2 w-full">
                <span className="text-sm font-bold text-gray-700">
                  Security Alerts
                </span>
                <div>
                  <div>
                    <div className="text-gray-600 font-medium">
                      {user?.security_question_status ? "Enabled" : "Disabled"}
                    </div>
                    <div className="text-gray-500">
                      {user?.security_question_status
                        ? "You have enabled security questions for additional account protection."
                        : "Set up a security question to help protect your account and recover access if needed."}
                    </div>
                  </div>
                </div>
                {!user?.security_question_status && (
                  <div className="flex gap-2 items-center">
                    <button
                      onClick={() => setShowSecurityQuestionModal(true)}
                      className="p-4 px-5 border-visaro-gray-300 border shadow-sm rounded-lg font-bold bg-white text-deepBlue text-sm w-fit"
                    >
                      Set Security Question
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Security;
